import { FormKitPattern } from '@/types/interfaces/ValidationRule.interface';

export const LowerCasePattern: FormKitPattern = {
  lowercased: true,
};
